import {
    Alert,
    Box,
    TableContainer,
    Table,
    TableBody,
    TableHead,
    Typography,
    TableRow,
    TableCell,
    Chip,
} from "@mui/material";
import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { GridCheckCircleIcon } from "@mui/x-data-grid";
import CancelIcon from "@mui/icons-material/Cancel";
import dayjs from "dayjs";

import PublisherDetailsStyle from "./style";

import DashboardContent from "@/components/app/DashboardContent";
import DashboardHeader from "@/components/app/DashboardHeader";
import ContentTable, { createData } from "@/components/app/ContentTable";
import { IContentsParams } from "@/api/types/content";
import { useContentsList } from "@/api/hooks/useContents";
import { usePublisherById } from "@/api/hooks/publisher";

export default function PublisherDetails() {
    const { id } = useParams();

    const [params, setParams] = useState<IContentsParams>({
        skip: 0,
        take: 10,
        filter: {
            publisher: Number(id) || null,
        },
    });

    const { data: PublisherData } = usePublisherById(Number(id));
    const { data: ContentData, isLoading, isFetching, isPending } = useContentsList(params);

    const handleChange = useCallback(({ page, rowsPerPage }: { page?: number, rowsPerPage?: number }) => {
        setParams((prev) => {
            return {
                ...prev,
                skip: Number(page) * Number(rowsPerPage),
                take: Number(rowsPerPage),
            };
        });
    }, []);

    const Data = ContentData?.data.items.map((item) => createData(item));

    return (
        <PublisherDetailsStyle>
            <>
                <DashboardHeader title="Publisher Details">
                    <Alert severity="info" sx={{ marginTop: "1em" }}>
                        See the details of this Publisher and the related content!
                    </Alert>
                </DashboardHeader>

                <DashboardContent>
                    <Box>
                        <Typography className="title" variant="h5">
                            Details of Publisher {id}
                        </Typography>
                        <br />
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="table-header">Publisher Title EN</TableCell>
                                        <TableCell className="table-header">Publisher Title AR</TableCell>
                                        <TableCell className="table-header">Content Count</TableCell>
                                        <TableCell className="table-header">Contact Name</TableCell>
                                        <TableCell className="table-header">Contact Phone</TableCell>
                                        <TableCell className="table-header">Contact Email</TableCell>
                                        <TableCell className="table-header">Contact Position</TableCell>
                                        <TableCell className="table-header">State</TableCell>
                                        <TableCell className="table-header">Updated At</TableCell>
                                        <TableCell className="table-header">Created At</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell className="table-header">
                                            {PublisherData?.data.ml_title.en || "-"}
                                        </TableCell>
                                        <TableCell className="table-header">
                                            {PublisherData?.data.ml_title.ar || "-"}
                                        </TableCell>
                                        <TableCell className="table-header">
                                            {PublisherData?.data.contentCount || "-"}
                                        </TableCell>
                                        <TableCell className="table-header">
                                            {PublisherData?.data.contactName || "-"}
                                        </TableCell>
                                        <TableCell className="table-header">
                                            {PublisherData?.data.contactPhone || "-"}
                                        </TableCell>
                                        <TableCell className="table-header">
                                            {PublisherData?.data.contactEmail || "-"}
                                        </TableCell>
                                        <TableCell className="table-header">
                                            {PublisherData?.data.contactPosition || "-"}
                                        </TableCell>
                                        <TableCell className="table-header">
                                            <Chip
                                                color={PublisherData?.data.isActive ? "success" : "error"}
                                                icon={
                                                    PublisherData?.data.isActive ? <GridCheckCircleIcon /> : <CancelIcon />
                                                }
                                                label={PublisherData?.data.isActive ? "Enabled" : "Disabled"}
                                                size="small"
                                                variant="outlined"
                                            />
                                        </TableCell>
                                        <TableCell className="table-header">
                                            {dayjs(PublisherData?.data.updatedAt).format("YYYY-MM-DD HH:mm")}
                                        </TableCell>
                                        <TableCell className="table-header">
                                            {dayjs(PublisherData?.data.createdAt).format("YYYY-MM-DD HH:mm")}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <br />
                    <br />
                    <Typography className="title" variant="h5">
                        Related Contents
                    </Typography>
                    <ContentTable
                        data={Data || []}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        isPending={isPending}
                        page={Number(params.skip) / Number(params.take)}
                        rowsPerPage={Number(params.take)}
                        totalItems={ContentData ? ContentData.data.pagination.totalItems : 0}
                        onChange={handleChange}
                    />
                </DashboardContent>
            </>
        </PublisherDetailsStyle>
    );
}
